import { render } from "./ChallengeFriend.vue?vue&type=template&id=58dab89f"
import script from "./ChallengeFriend.vue?vue&type=script&lang=js"
export * from "./ChallengeFriend.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__